var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/AssemblyClassifier.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { Id } from '../Id';
import { Version, VersionData, VersionDates, Versions } from '../Version';
import { BaseClassifier } from '../BaseClassifierRepo';
import { createPredicate } from '../createPredicate';
import { BimReference } from '../BimReference';
import { ApiDomain } from '../domain';
import { BimModel } from '..';
import { Urn } from '../Urn';
export var AssemblyStatus = t.union([t.literal('NotStarted'), t.literal('Pending'), t.literal('InProcess'), t.literal('Error'), t.literal('Canceled'), t.literal('Done')]);
export var AssemblyClassifier;

(function (_AssemblyClassifier) {
  var domain = ApiDomain.domain('AssemblyClassifier', {
    name: "domain",
    sid: "-p9bp4f"
  });
  var AssemblyStatusChangeEvent = _AssemblyClassifier.AssemblyStatusChangeEvent = t.type({
    type: t.literal('AssemblyStatusChangeEvent'),
    payload: t.type({
      classifierId: Id,
      classifierVersion: Version,
      status: AssemblyStatus
    })
  });
  var type = _AssemblyClassifier.type = 'AssemblyClassifier';
  var io = _AssemblyClassifier.io = t.recursion('AssemblyClassifier', function () {
    return t.type({
      type: t.literal(type),
      id: Id,
      version: Version,
      parentFolderId: t.union([t["null"], Id]),
      sourceClassifiers: t.readonlyArray(BaseClassifier.io),
      name: t.string,
      readOnly: t["boolean"],
      owner: t.union([t["null"], t.string]),
      versionNameOwner: t.union([t["null"], t.string]),
      versionCreatedDate: t.string,
      versionName: t.union([t["null"], t.string]),
      status: AssemblyStatus,
      assemblyModelRef: t.union([t["null"], BimReference.Model.io]),
      projectUrn: Urn
    });
  });
  var is = _AssemblyClassifier.is = createPredicate(type);
  var create = _AssemblyClassifier.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: io,
    getKey: ['name', 'parentFolderId', 'projectUrn']
  });
  var copy = _AssemblyClassifier.copy = ApiCallService.create({
    name: 'copy',
    parentDomain: domain,
    result: AssemblyClassifier.io,
    getKey: ['name', 'id', 'version']
  });
  var fetch = _AssemblyClassifier.fetch = ApiCallService.create({
    name: 'fetch',
    parentDomain: domain,
    result: AssemblyClassifier.io,
    getKey: ['id', 'version']
  });
  var fetchSourceModels = _AssemblyClassifier.fetchSourceModels = ApiCallService.create({
    name: 'fetch',
    parentDomain: domain,
    result: t.recursion('BimModel', function () {
      return BimModel.io;
    }),
    getKey: ['id', 'version']
  });
  var getMostRecent = _AssemblyClassifier.getMostRecent = ApiCallService.create({
    name: 'getMostRecent',
    parentDomain: domain,
    result: AssemblyClassifier.io,
    getKey: ['id']
  });
  var getMostRecentSilent = _AssemblyClassifier.getMostRecentSilent = ApiCallService.create({
    name: 'getMostRecentSilent',
    parentDomain: domain,
    result: AssemblyClassifier.io,
    getKey: ['id']
  });
  var rename = _AssemblyClassifier.rename = ApiCallService.create({
    name: 'rename',
    parentDomain: domain,
    result: io,
    getKey: ['id', 'version']
  });
  var move = _AssemblyClassifier.move = ApiCallService.create({
    name: 'move',
    parentDomain: domain,
    result: io,
    getKey: ['id', 'version']
  });
  var remove = _AssemblyClassifier.remove = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: io,
    getKey: ['id']
  });
  var addDependency = _AssemblyClassifier.addDependency = ApiCallService.create({
    name: 'addDependency',
    parentDomain: domain,
    result: io,
    getKey: ['id', 'version', 'sourceClassifierId', 'sourceClassifierVersion']
  });
  var removeDependency = _AssemblyClassifier.removeDependency = ApiCallService.create({
    name: 'removeDependency',
    parentDomain: domain,
    result: io,
    getKey: ['id', 'version', 'sourceClassifierId']
  });
  var fetchVersionDates = _AssemblyClassifier.fetchVersionDates = ApiCallService.create({
    name: 'modelElementEstimationStatus',
    parentDomain: domain,
    result: VersionDates.io,
    getKey: ['classifierId']
  });
  var fetchVersionByDate = _AssemblyClassifier.fetchVersionByDate = ApiCallService.create({
    name: 'modelElementEstimationStatus',
    parentDomain: domain,
    result: Versions.io,
    getKey: ['classifierId']
  });
  var renameVersion = _AssemblyClassifier.renameVersion = ApiCallService.create({
    name: 'renameVersion',
    parentDomain: domain,
    result: VersionData.io,
    getKey: ['classifierId', 'classifierVersion', 'versionName']
  });
  var removeVersionName = _AssemblyClassifier.removeVersionName = ApiCallService.create({
    name: 'removeVersionName',
    parentDomain: domain,
    result: VersionData.io,
    getKey: ['classifierId', 'classifierVersion']
  });
  var fetchNamedVersions = _AssemblyClassifier.fetchNamedVersions = ApiCallService.create({
    name: 'fetchNamedVersions',
    parentDomain: domain,
    result: Versions.io,
    getKey: ['classifierId']
  });
  var runAssembly = _AssemblyClassifier.runAssembly = ApiCallService.create({
    name: 'runAssembly',
    parentDomain: domain,
    result: io,
    getKey: ['id', 'version']
  });
})(AssemblyClassifier || (AssemblyClassifier = {}));